const ORGANIZATION_MODEL_PATH = "App\\Models\\Organization";
import { userRoles } from "@/constants/UserRoles";

export const isOrganizationRole = ({ role, organizationId }) => {
  return (
    !role.subject_type ||
    (role.subject_type === ORGANIZATION_MODEL_PATH &&
      role.subject_id === organizationId)
  );
};

export const sortRoleByPriority = (roleA, roleB) => {
  const aPriority = userRoles.find((role) =>
    roleA.name.includes(role.name)
  )?.priority;

  const bPriority = userRoles.find((role) =>
    roleB.name.includes(role.name)
  )?.priority;

  return aPriority - bPriority;
};

export const getOrganizationMainRoles = ({ roles, organizationId }) =>
  roles
    ?.filter((role) => isOrganizationRole({ role, organizationId }))
    .sort(sortRoleByPriority);
